<template>
    <div class="vuetable-filterbar col-md-12">
	    <div class="form-group p-l">
            <b-container fluid class="p-a-0">
                <b-row no-gutters>
                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="filterTextNavioViagem" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Navio / Viagem</label>
                        </div>
                    </b-col>

                    <b-col sm="6" md="3" class="m-t-5px p-a-0">
                        <multiselect v-model="filterTextPortoOrigem"
                        :options="optionsPortoOrigem"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Porto Origem"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>

                    <b-col sm="6" md="3" class="m-t-5px p-a-0">
                        <multiselect v-model="filterTextPortoDestino"
                        :options="optionsPortoDestino"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Porto Destino"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>

                    <b-col sm="6" md="2" class="m-t-5px">
                        <div class="input-group-btn">
                          <div class="btn-group">
                            <button type="button" class="btn btn-secondary btn-outline" @click="doFilter" :disabled="vuetableFilterButton">Filtrar</button>
                            <button type="button" class="btn btn-secondary btn-outline" @click="resetFilter" :disabled="vuetableFilterButton">Limpar</button>
                          </div>
                        </div>
                    </b-col>

                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      filterTextNavioViagem: '',
      filterTextPortoOrigem: '',
      filterTextPortoDestino: '',
      optionsPortoOrigem: [],
      optionsPortoDestino: [],
      data_filter: [],
      helpForm: new Form({statusRecord: [], params: []}),
    }
  },
  mounted() {
      this.getPortos();
    },
    methods: {
        getPortos() {
            this.helpForm.get('/api/porto/jsonlist').then(response =>
            {
                new ReturnApi(response, this, true, false, false);
                response.items.forEach((obj)=>
                {
                    this.optionsPortoOrigem.push({ label: obj.nome, value: obj.porto_id })
                    this.optionsPortoDestino.push({ label: obj.nome, value: obj.porto_id })
                })
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        doFilter () {
            this.$store.commit('setVuetableFilterButton', true);
            this.data_filter = {filterTextNavioViagem: this.filterTextNavioViagem,
                                filterTextPortoDestino: this.filterTextPortoDestino,
                                filterTextPortoOrigem: this.filterTextPortoOrigem};
            this.$events.fire('filter-set', this.data_filter);
        },
        resetFilter () {
            this.filterTextNavioViagem = '';
            this.filterTextPortoDestino = '';
            this.filterTextPortoOrigem = '';
            this.$events.fire('filter-reset');
        }
    },
    computed: {
        vuetableFilterButton: {
            get () {
                return this.$store.state.vuetable.filterButton;
            },
        },
    }
}
</script>
